import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import { Button } from "components";
import { UserProfileFields } from "globalConstants";
import { dropdownValuesActions } from "store";

import styles from "../userForm.module.scss";

type CopyFromAgentOfficeProps = {
	isLoading?: boolean;
};

const CopyFromAgentOffice = ({
	isLoading = false,
}: CopyFromAgentOfficeProps) => {
	const { Phone, MobilePhone, Address, City, State, Zip, Country } =
		UserProfileFields;
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(dropdownValuesActions.getCompanies());
	}, [dispatch]);

	const { setValue, getValues } = useFormContext();

	const copyFromAgentOffice = () => {
		const agentOffice = getValues("agentOffice");

		if (agentOffice) {
			setValue(Phone.name, agentOffice.csPhone);
			setValue(MobilePhone.name, agentOffice.mobile);
			setValue(Address.name, agentOffice.address);
			setValue(City.name, agentOffice.city);
			setValue(State.name, agentOffice.state);
			setValue(Zip.name, agentOffice.zip);
			setValue(Country.name, agentOffice.country);
		}
	};

	return (
		<Button
			variant="secondary"
			value="COPY FROM AGENT OFFICE"
			onClick={copyFromAgentOffice}
			className={styles.copyButton}
			isLoading={isLoading}
		/>
	);
};

export default CopyFromAgentOffice;
